import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAffiliateFAQs } from '../../services/FAQApi';
import { toastNotify } from '../../utils/toastNotify';

const initialState = {
  loading: false,
  data: {},
};

export const fetchAffiliateFAQs = createAsyncThunk('FETCH_AFFILIATE_FAQS', getAffiliateFAQs);

export const affiliateFaqSlice = createSlice({
  name: 'affiliateFaqs',
  initialState,
  reducers: {
    resetAffiliateFAQsList: (state) => {
      state.loading = false;
      state.data = {};
    },
  },
  extraReducers: {
    [fetchAffiliateFAQs.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchAffiliateFAQs.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    },
    [fetchAffiliateFAQs.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
  },
});

export const { resetAffiliateFAQsList} = affiliateFaqSlice.actions;

const { reducer } = affiliateFaqSlice;

export default reducer;
